import api from '@/api';

const state = {
	items: [],
	updated: 0,
	itemsNeedToRefresh: 0,
};

const getters = {};

const actions = {
	get: ({ commit }, { refresh = false, updateStore = false, ...params }) => {
		return new Promise((resolve, reject) => {
			const { updated } = state;
			if (!refresh && updated > 0) {
				resolve({ data: { items: state.items } });
			}
			api.users
				.get(params)
				.then(response => {
					const { items } = response.data;
					if (updateStore) {
						commit('setItems', { items });
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	post: ({ commit }, { updateStore = false, ...params }) => {
		return new Promise((resolve, reject) => {
			api.users
				.post(params)
				.then(response => {
					// console.log(response.data[0].status);
					// if (response.data[0].status === 'User is not a valid Azure Active Directory member') {
					//   reject('not-azure-member');
					// }
					if (updateStore) {
						const { items } = response.data;
						commit('addItems', { items });
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	put: ({ commit }, { updateStore = false, ...params }) => {
		return new Promise((resolve, reject) => {
			api.users
				.put(params)
				.then(response => {
					if (updateStore) {
						const { items } = response.data;
						commit('updateItems', { items });
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
};

const mutations = {
	setItems: (state, { items }) => {
		const now = new Date();
		state.items = items;
		state.updated = now.getTime();
	},
	setItemsNeedToRefresh: state => {
		const now = new Date();
		state.itemsNeedToRefresh = now.getTime();
		state.updated = now.getTime();
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
